import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import projectLocationServices from '../companyLocationServices';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';


function CompanyLocationForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const [coords, setCoords] = useState({ lat: null, lng: null });

    const initialValues = {
        title:"",
        orgName:"",
        city:"",
        state:"",
        address:"",
        zip:"",
        lat:"",
        lng:"",
        radious:"50"
        
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            title:data.title,
            orgName:data.orgName,
            city:data.city,
            state:data.state,
            address:data.address,
            zip:data.zip,
            lat:data.lat,
            lng:data.lng,
            radious:data.radious,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        title:Yup.string().required("Required"),
        orgName:Yup.string().required("Required"),
        city:Yup.string().required("Required"),
        //radious:Yup.number().min(50).max(1000).required("Required"),
        
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        projectLocationServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Location</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Company Location"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Location/Warehouse/Godown Name" name="title" 
                                                        
                                                    />
                                                </div>
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Org." name="orgName"   
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="City" name="city"   
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="State" name="state"  
                                                        options={masters['indian-state']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Pincode" name="zip"   
                                                    />
                                                </div>

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Address" name="address"   
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Latitude ie: 28.************* " name="lat"
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Longitude ie: 73.************" name="lng"  
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number"
                                                        label="Attendance Radious" name="radious"
                                                    />
                                                </div>


                                                {/*

                                                <div className='col-md-12'>
                                                    <h1>Pick a Location</h1>
                                                    <p>Selected: {coords.lat}, {coords.lng}</p>                                                    
                                                    <LocationPicker onLocationChange={(coords) =>setCoords(coords)} />
                                                </div>

                                                */}
                                                
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit" disabled={!formik.isValid} >Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default CompanyLocationForm